import React, { useState, useContext } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'
import ClientCaseTypeForm from './ClientCaseTypeForm'
import ClientCaseTypeList from './ClientCaseTypeList'
import { toast } from '../../../common/Toast'
import ClientPageContext from './ClientPageContext'

const AddCaseTypeTab = (): JSX.Element => {
    const [open, setOpen] = useState(false)
    const ctx = useContext(ClientPageContext)
    const [refreshKey, setRefreshKey] = useState(0)

    const handleSuccess = (client: any) => {
        ctx.setClient(client)
        setOpen(false)
   
        setRefreshKey(prev => prev + 1)
    }

    const handleUpdateSuccess = () => {
        setRefreshKey(prev => prev + 1)
    }

    return (
        <>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                size="tiny"
                closeIcon
                closeOnDimmerClick={false}
                closeOnEscape={false}
                trigger={
                    <Button icon labelPosition="left" color="green" onClick={() => setOpen(true)}>
                        <Icon name="add" />
                        Create New
                    </Button>
                }
            >
                <Modal.Header>Create New Case Type</Modal.Header>
                <Modal.Content>
                    <ClientCaseTypeForm
                        onSuccess={handleSuccess}
                    />
                </Modal.Content>
            </Modal>
            <ClientCaseTypeList 
                refreshTrigger={refreshKey} 
                onUpdateSuccess={handleUpdateSuccess}
            />
        </>
    )
}

export default AddCaseTypeTab


